import { render, staticRenderFns } from "./BasicTable.vue?vue&type=template&id=75a0eeda&scoped=true&"
import script from "./BasicTable.vue?vue&type=script&lang=js&"
export * from "./BasicTable.vue?vue&type=script&lang=js&"
import style0 from "./BasicTable.vue?vue&type=style&index=0&id=75a0eeda&prod&lang=scss&"
import style1 from "./BasicTable.vue?vue&type=style&index=1&id=75a0eeda&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a0eeda",
  null
  
)

export default component.exports